import React, { useContext, useEffect, useState } from 'react';
import { WebApp } from 'src/app/web-app';
import { PlatformProvider, usePlatform } from 'src/business/context/platform-context';
import { AppContextProvider, SessionContext } from 'src/business/context/session-context';
import './index.css';
import { useCustomFavicon } from 'src/business/hook/use-custom-favicon';
import { Spinner } from 'src/component/util/spinner';
import { Router } from 'src/screen/router';
import { logger } from 'src/util/logger';

export const App = (): React.ReactElement => {
	const { isLoading: sessionIsLoading } = useContext(SessionContext);
	const [webApp] = useState(new WebApp());
	const [isLoading, setIsLoading] = useState(true);

	const { platformName } = usePlatform();

	useCustomFavicon();

	useEffect(() => {
		document.title = `${platformName} Auth`;
	}, [platformName]);

	useEffect(() => {
		setIsLoading(true);
		webApp
			.create()
			.then(() => {
				setIsLoading(false);
			})
			.catch((err) => logger().error(err));
	}, [webApp]);

	if (sessionIsLoading || isLoading) return <Spinner />;
	return (
		<div className="App">
			<Router />
		</div>
	);
};

export const AppWrapper = (): JSX.Element => {
	return (
		<AppContextProvider>
			<PlatformProvider>
				<App />
			</PlatformProvider>
		</AppContextProvider>
	);
};
